import { config } from '../constants/config';
import { tokenStorage } from './tokenStorage';

interface ExportOptions {
  search?: string;
  businessSystemId?: string;
  sortBy?: string;
  sortDescending?: boolean;
}

export async function downloadOrganizationsCSV(options: ExportOptions = {}) {
  const params = new URLSearchParams();
  
  if (options.search) params.append('search', options.search);
  if (options.businessSystemId) params.append('businessSystemId', options.businessSystemId);
  if (options.sortBy) params.append('sortBy', options.sortBy);
  if (options.sortDescending) params.append('sortDescending', 'true');

  const url = `${config.apiUrl}/api/organizations/export?${params.toString()}`;
  
  try {
    const token = tokenStorage.getAccessToken();
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to export data');
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    
    // Extract filename from Content-Disposition header or use default
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'organizations_export.csv';
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }

    // Create download link and trigger download
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
    
    return true;
  } catch (error) {
    console.error('Export failed:', error);
    throw error;
  }
}